import React from 'react';
import Promise from 'promise';

export default class BrandkitForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brandkitName: this.companyName,
      brandkitNameValid: false,
      brandkitNameHasBlurred: false,
      brandkitUrl: this.companyUrl,
      brandkitUrlValidOrEmpty: true,
      brandkitUrlHasBlurred: false
    };
  };

  componentDidMount() {
    if (this.companyName) {
      this.validateSlug();
    }
  }

  get companyName() {
    if(this.props.company && this.props.company.name) {
      return this.props.company.name;
    }
  }

  get companyUrl() {
    if(this.props.company && this.props.company.domain) {
      return `http://${this.props.company.domain}`;
    }
  }

  updateValue(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  brandkitNameToSlug() {
    if(this.state.brandkitName) {
      return this.state.brandkitName.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');
    }
  }

  handleSlugChangeEvent(e, regex) {
    this.setState({brandkitNameValid: this.regexValidator(e, regex)});
  }

  handleSlugBlurEvent(e) {
    Promise.all([this.updateValue(e)]).then( () => {
      this.validateSlug();
    });
    this.setState({brandkitNameHasBlurred: true});
  }

  handleDomainChangeEvent(e, regex) {
    if(!e.target.value) {
      this.updateValue(e); // Want to set the state to undefined
      this.setState({brandkitUrlValidOrEmpty: true});
    } else if(this.regexValidator(e, regex)) {
      this.updateValue(e);
      this.setState({brandkitUrlValidOrEmpty: true});
    } else {
      this.setState({brandkitUrl: null, brandkitUrlValidOrEmpty: false});
    }
  }

  regexValidator(e, regex) {
    let input = e.target.value;
    return regex.test(input)
  }

  validateSlug() {
    let xhr = new XMLHttpRequest();
    let url = `/brandkits/existant_slug/${this.brandkitNameToSlug()}`;
    xhr.open('GET', url, true);
    let that = this;
    xhr.setRequestHeader("X-CSRF-TOKEN", this.props.authenticityToken)
    xhr.setRequestHeader("Content-type", 'application/json')
    xhr.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 409) {
        swal({title: "Time to get creative!", text: `The name ${that.state.brandkitName} has already been claimed!`, type: "error" });
        that.setState({brandkitName: null, brandkitNameHasBlurred: false});
        document.getElementsByName('brandkitName')[0].value = null;
      } else if (this.readyState == 4 && this.status == 200) {
      }
    }
    xhr.send();
  }

  kickoffCompanyScrapeJob() {
    let xhr = new XMLHttpRequest();
    let params = {url: this.state.brandkitUrl};
    xhr.open('POST', '/api/v3/company_info', true);
    xhr.setRequestHeader("X-CSRF-TOKEN", this.props.authenticityToken);
    xhr.setRequestHeader("Content-type", 'application/json');
    xhr.send(JSON.stringify(params));
  }

  submitBrandkitData(e) {
    e.preventDefault();

    if (!this.state.brandkitName || !this.brandkitNameToSlug) {
      swal({title: "Error!", text: 'Your Brand Kit must have a name.', type: "error" });
      return
    }

    if (this.state.brandkitUrl) {this.kickoffCompanyScrapeJob()};

    this.props.createBrandkit({
      slug: this.brandkitNameToSlug(),
      name: this.state.brandkitName,
      url: this.state.brandkitUrl
    });
  }

  setBtnClass() {
    return this.props.createBrandkitLoading ? 'create-brandkit-loading dark' : 'dark';
  }

  buttonDisabledState() {
    return !(this.state.brandkitNameValid
             && this.state.brandkitUrlValidOrEmpty)
  }

  renderValidator(valid, msg) {
    if (!valid) {
      return (<div className='field-validation field-validation-url'>{msg}</div>)
    }
  }

  render() {
    return(
      <div className='content content--step4'>
        <form>
            <h3>Let's get some general information to start building your Brandfolder</h3>
            <div className='row row-full'>
              <label htmlFor='brandkitName'>Brandfolder Name</label>
              <input  className={(this.state.brandkitNameValid || !this.state.brandkitNameHasBlurred) ? '' : 'input-invalid'}
                      type='text'
                      name='brandkitName'
                      autoComplete='off'
                      defaultValue={this.companyName}
                      onBlur={(e) => this.handleSlugBlurEvent(e)}
                      onChange={(e) => this.handleSlugChangeEvent(e, /.{3,}/)} />
              {this.renderValidator((this.state.brandkitNameValid || !this.state.brandkitNameHasBlurred), 'More than 3 characters are required for a name')}
            </div>
            <div className='row row-full'>
              <label htmlFor='brandkitUrl'>Your Website URL (Optional)</label>
              <input  className={(this.state.brandkitUrlValidOrEmpty || !this.state.brandkitUrlHasBlurred) ? '' : 'input-invalid'}
                      type='text'
                      name='brandkitUrl'
                      autoComplete='off'
                      defaultValue={this.companyUrl}
                      onBlur={(e) => this.setState({brandkitUrlHasBlurred: true})}
                      onChange={(e) => this.handleDomainChangeEvent(e, /^(https?:\/\/)?[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/)} />
              {this.renderValidator((this.state.brandkitUrlValidOrEmpty || !this.state.brandkitUrlHasBlurred), 'A valid domain is required')}
            </div>
        </form>
        <button disabled={this.buttonDisabledState()} className={this.setBtnClass()} onClick={(e) => this.submitBrandkitData(e)}>
          Show Me My Brandfolder
        </button>
      </div>
    )
  }
}
